import React, { useState } from 'react'
import "./css/Home.css"
import 'bootstrap/dist/css/bootstrap.css';
import Navbar from './Navbar';

import Image1 from './images/image1.jpeg';
import founderImage from './images/founderImage.jpg';
import Image2 from './images/image2.jpeg';
import Image3 from './images/image3.jpeg';
import Image4 from './images/image4.jpeg';
import Image5 from './images/image5.jpeg';
import Image6 from './images/image6.jpeg';

const Home = () => {

    const [name, setName] = useState('');

    const studentSearch = async (e) => {
        e.preventDefault()
        const response = await fetch('https://jivichem.herokuapp.com/api/v1/product/search', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json'
            },
            body: JSON.stringify({
                name
            }),
        })

        const data = await response.json()
        console.log(data.user)
        if (data.user) {
            localStorage.setItem('token', data.user);
            window.location.href = "/product_details"
        } else {
            alert("please check your roll")
        }
    }
    return (
        <>
            <Navbar />
            <section className="first-half">

                <div className="body">
                    <div className="Description2">
                        <h1 className="Title">Jivichem Synthesis Private Limited</h1>
                    </div>
                    <div className="Description">
                        <h2 className="Description__h2">A one-stop destination for all your research needs</h2>
                    </div>
                    <div className="midHead">
                        <button type="button" className="change btn btn-outline-danger">Product Tree</button>
                        <button type="button" className="change btn btn-outline-warning">COA & MSDS</button>
                        <button type="button" className="change btn btn-outline-info">Download Catalogue</button>
                    </div>
                    <form onSubmit={studentSearch} className="formm">
                        <input className="formInput"
                            type="text"
                            id="name"
                            value={name}
                            onChange={(e) => setName(e.target.value)}
                            placeholder="Type Here To Search"
                        />
                    </form>
                </div>

            </section>


            <section className="second-half">
                <div className="carda" >
                    <img className="cardImg" src={founderImage} alt="" />
                    <div className="cardBody">
                        <h5 className="cardBody__h5">Founded By : Mr.XYZ</h5>
                        <p className="cardBody__p">Lorem ipsum dolor sit amet consectetur adipisicing elit. Natus, assumenda? Voluptas
                            accusantium quam temporibus perferendis excepturi nam maxime reprehenderit veniam totam ducimus ullam rerum
                            adipisci omnis expedita neque ad, voluptatum at fugiat saepe asperiores earum reiciendis iure! Inventore
                            quos blanditiis veniam esse distinctio officia sequi alias sint repudiandae quaerat, quasi tempore, dolorem
                            ullam delectus. Debitis deserunt mollitia in!
                        </p>
                    </div>
                </div>

                <div className="carda">
                    <img className="cardImg" src={Image2} alt="" />
                    <div className="cardBody">
                        <h5 className="cardBody__h5">Jivichem</h5>
                        <p className="cardBody__p">Jivichem Syntheis Pvt Ltd is a reliable source for drug and Intermediates. The company
                            has research and development facilities to produce Organic & inorganic Intermediates that have the potential
                            to become drugs of the future. It offers screening compounds that accelerate drug discovery programs. The
                            company is dedicated to discovering molecules.
                            Following is our Outstanding Service:
                            Research and Development of synthesis for the production of most
                        </p>
                    </div>
                </div>
            </section>

            <section className="third-half">
                <h1 className="third-half__h1">Product Categories</h1>


                <div className="third-half__content">

                    <div className='third-half___main-content'>
                        <h3 className='third-half__main-content__h3'>Speciality Chemicals</h3>
                        <div className='main-content_2'>
                            <div className="boxx">
                                <img src={Image1} alt="" />
                                <a href="Micro Biology">Speciality Chemicals</a>
                            </div>
                        </div>
                    </div>

                    <div className='third-half___main-content'>
                        <h3 className='third-half__main-content__h3'>Biologics</h3>
                        <div className='main-content_2'>
                            <div className="boxx">
                                <img src={Image2} alt="" />
                                <a href="Micro Biology">Micro Biology</a>
                            </div>
                            <div className="boxx">
                                <img src={Image3} alt="" />
                                <a href="Proteomics">Proteomics</a>
                            </div>
                            <div className="boxx">
                                <img src={Image4} alt="" />
                                <a href="BioChemicals">BioChemicals</a>
                            </div>
                            <div className="boxx">
                                <img src={Image5} alt="" />
                                <a href="Immunology">Immunology</a>
                            </div>
                            <div className="boxx">
                                <img src={Image6} alt="" />
                                <a href="Moleculer Biology">Moleculer Biology</a>
                            </div>

                        </div>
                    </div>
                </div>
            </section>
        </>
    )
}
export default Home;